import { render, staticRenderFns } from "./r-preview-dialog.vue?vue&type=template&id=2bf6e62a"
import script from "./r-preview-dialog.vue?vue&type=script&lang=js"
export * from "./r-preview-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-preview-dialog.vue?vue&type=style&index=0&id=2bf6e62a&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf6e62a')) {
      api.createRecord('2bf6e62a', component.options)
    } else {
      api.reload('2bf6e62a', component.options)
    }
    module.hot.accept("./r-preview-dialog.vue?vue&type=template&id=2bf6e62a", function () {
      api.rerender('2bf6e62a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/preview/r-preview-dialog.vue"
export default component.exports